import AbstractAnalyticsProvider from './AbstractAnalyticsProvider';

type ImpactAnalytics = (
  eventName: 'identify',
  payload: Partial<Record<'customerid' | 'customeremail', string>>,
) => void;

declare global {
  interface Window {
    ire: ImpactAnalytics;
  }
}

const encodeToSha1 = (value: string): Promise<string> => {
  // inlined SHA-1 encoding https://stackoverflow.com/a/69399958/5562460
  return window.crypto.subtle.digest('SHA-1', new TextEncoder().encode(value)).then((digest) =>
    Array.from(new Uint8Array(digest))

      .map((b) => b.toString(16).padStart(2, '0'))
      .join(''),
  );
};

class ImpactProvider extends AbstractAnalyticsProvider {
  // eslint-disable-next-line @typescript-eslint/member-ordering -- members before methods
  protected irEvent?: ImpactAnalytics;

  init(): void {}

  trackProfile(userId?: string, email?: string) {
    if (email && userId) {
      void encodeToSha1(email).then((encodedEmail) => {
        window.ire('identify', {
          customeremail: encodedEmail,
          customerid: userId,
        });
      });
    } else if (userId) {
      window.ire('identify', {
        customerid: userId,
      });
    }
  }

  trackPurchase(): void {
    // if (this.irEvent) this.irEvent.fire();
  }
}

export default ImpactProvider;
